const scheduleIntervalStyle = (schedule) => {
    if (schedule?.dtendtime) {
        return 'time-' + (schedule.dtstarttime.length === 4 ? '0' : '') + schedule.dtstarttime.replace(':', '') + ' / time-' + (schedule.dtendtime.length === 4 ? '0' : '') + schedule.dtendtime.replace(':', '');
    } else {
        return 'time-' + (schedule.dtstarttime.length === 4 ? '0' : '') + schedule.dtstarttime.replace(':', '');
    }
}

const roomIntervalStyle = (schedule, rooms) => {
    if (schedule?.rooms?.startRoom === null && schedule?.rooms?.endRoom === null && rooms !== undefined) {
        return 'track-1-start / track-' + rooms.sort((a, b) => b.id - a.id)[0].id + '-end';
    }
    if (schedule?.rooms?.endRoom) {
        return 'track-' + schedule?.rooms?.startRoom + '-start / track-' + schedule?.rooms?.endRoom + '-end';
    } else {
        return 'track-' + schedule?.rooms?.startRoom;
    }
}


const Event = ({event, rooms, timeSlot, eventMenuLink}) => {
    return (
        <>
            {timeSlot !== false ?
                <h2 className="time-slot" style={{gridRow: `time-${timeSlot.replace(':', '')}`}}>{timeSlot}</h2> : ''
            }
            <div className={`session session-common session-${event.id} track-${event.rooms.startRoom}`}
                 style={{
                     gridColumn: roomIntervalStyle(event, rooms),
                     gridRow: scheduleIntervalStyle(event),
                     backgroundColor: event?.rooms?.color,
                 }}>
                <h3 className="session-title"><a href={`/${eventMenuLink}/${event.alias}-${event.id}/detail.html`}>
                    <>
                    <span style={{marginBottom: '0rem'}}>
                        {event.name.split(':')[0]}{event.name.includes(':') ? ':' : ''}
                    </span><br/>
                        <span style={{
                            textTransform: 'none',
                            fontWeight: 'initial'
                        }}>
                        {event.name.split(':')[1]}</span>
                    </>
                </a></h3>
                <span className="session-presenter">{event.sponsor}</span>
                <span
                    className="session-time"
                    style={{color: 'white'}}>{event.dtstarttime} {event.dtendtime ? '- ' + event.dtendtime : ''}</span>
                {event?.mainRoom ?
                    <span className="session-track">{event.mainRoom}</span>
                    :
                    ''
                }
            </div>
        </>
    )
}
export default Event